import type { ReelTumbleTuning } from "@slot/mechanics-reels";

// Per-game TUMBLE values (opt-in tumbling-reels variant). Shape comes from
// mechanics/reels/public. Starting defaults mirror the cascade feel (Game-A-style
// cluster/mask wins → remove → gravity drop-in refill). Tunable.
export const REEL_TUMBLE_TUNING: ReelTumbleTuning = {
  // Winning cells are destroyed (each plays its Spine `out`; symbols without the clip — CH/FS —
  // shrink + burst; a detonating chance barrel leaves with its own `win` instead), then a short
  // hold (the chance detonation's removal keeps it too). Both staggers are 0: the whole mask is
  // destroyed on ONE frame, matching the win highlight above (`symbolAnimStaggerMilliseconds: 0`)
  // so the win and its removal read as a single simultaneous beat rather than two waves crossing
  // the cluster.
  // The beat is then just the clip: 0.333s + the hold, independent of cluster size or shape.
  removal: {
    shrinkSeconds: 0.15,
    postRemovalHoldSeconds: 0.1,
    columnStaggerSeconds: 0,
    withinColumnStaggerSeconds: 0,
  },
  // Survivors fall + new symbols drop in from above. Distance-based timing
  // (constant visual fall speed) with flat fallbacks; small overshoot-and-settle.
  tumble: {
    fallDurationSeconds: 0.25,
    spawnDurationSeconds: 0.28,
    columnStaggerSeconds: 0.06,
    withinColumnStaggerSeconds: 0.02,
    dropSpeedPixelsPerSecond: 2600,
    minDropDurationSeconds: 0.06,
    maxDropDurationSeconds: 1.2,
    overshoot: {
      enable: true,
      pixels: 8,
      phaseRatio: 0.82,
      settleEasing: "quadOut",
    },
  },
};
